import React from "react";
import { NavLink } from "react-router-dom";
import { Alert } from "@material-ui/lab";
import { decimalFixedMid } from "../../../utils/consts";
import { getServiceNameWithNickname } from "../../../utils/getServiceNameWithNickname";
import { StyledBreakWord } from "../../styles/styledBreakWord";
import PageSpinner from "../spinner/PageSpinner";
import DiffAmountNotification from "./BalanceDiffAmountNotification";
import { useTranslation } from "react-i18next";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../styles/styledTable";

const BalancesList = ({ balances, setBalances }) => {
  const { t } = useTranslation("accountPage");

  if (!balances) {
    return <PageSpinner position="center" pt="20" pb="20" />;
  }

  if (balances.length === 0) {
    return <Alert severity="warning">{t("balances.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable
        width="768"
        size="14"
        className="user-balances-table"
      >
        <StyledTableHead
          scroll="auto"
          col="5"
          className="user-balances-table__head"
        >
          <div>
            {t("balances.table.service")}
          </div>
          <div>
            {t("balances.table.balance")}
          </div>
          <div>
            {t("balances.table.currency")}
          </div>
          <div>
            {t("balances.table.holdingBalance")}
          </div>
          <div>
            {t("balances.table.availableBalance")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {balances && balances.map((value, key) => (
            <StyledTableRow
              key={key}
              scroll="auto"
              col="5"
              className="user-balances-table__row"
            >
              <StyledCol>
                <div>
                  <NavLink className="default-link" to={`/services/${value.service.id}`}>
                    {getServiceNameWithNickname(value.service.name, value.service.nickname)}
                  </NavLink>
                </div>
              </StyledCol>
              <StyledCol className="user-balances-table__amount">
                <div className="amount">
                  <StyledBreakWord
                    className="default-link"
                    as={NavLink}
                    to={`/cash-flow?currentTab=balances-history&service=${value.service.name}&user=${value.user.email}&currency=${value.currency.asset}`}
                  >
                    {parseFloat(value.amount).toFixed(decimalFixedMid)}
                  </StyledBreakWord>
                  <DiffAmountNotification balances={balances} setBalances={setBalances} diff={value.diff} />
                </div>
              </StyledCol>
              <StyledCol>
                {value.currency.asset}
              </StyledCol>
              <StyledCol className="user-balances-table__amount">
                <div className="amount">
                  <StyledBreakWord as="p">
                    {value.holdingBalance}
                  </StyledBreakWord>
                </div>
              </StyledCol>
              <StyledCol className="user-balances-table__amount">
                <div className="amount">
                  <StyledBreakWord as="p">
                    {value.availableBalance}
                  </StyledBreakWord>
                </div>
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default BalancesList;